import { Form } from "antd"
import { Group, RadioButtons } from "components/common"
import Legend from "components/common/legend/legend"
import { t } from "i18next"
import UploadDraggerS3 from "features/shared/components/uploadDraggerS3/uploadDraggerS3"
import { useAddSalesContext } from "../../../addSalesContext/addSalesContext"
import { customValidatorForSaleType } from "../../../utils"
import { saleTypeOptions } from "constants/list"

const bankLoanSubTypeOptions = () => [
  {
    label: t("Internal"),
    value: "internal",
  },
  {
    label: t("External"),
    value: "external",
  },
]

const SaleTypeBookingOptions = ({ rules }) => {
  const { addSalesApis, form, setImageUploading, formWatchers } = useAddSalesContext()
  const { project, bookingPlatform, saleType } = formWatchers
  const { activeBookingPlatforms, mortgageAssessment, leadSalesInfo } = addSalesApis

  const showBookingPlatforms = leadSalesInfo?.isFirstSalesTask && activeBookingPlatforms?.length

  return (
    <>
      {project?.mortgageSaleAllowed || showBookingPlatforms ? <Legend title={t("Sale Type")} /> : null}
      <Group template="repeat(2,1fr)" gap="0 24px">
        {project?.mortgageSaleAllowed ? (
          <Form.Item
            required
            name={"saleType"}
            label={t("Sale Type")}
            rules={rules.concat({
              validator: async (_, value) => {
                return customValidatorForSaleType(value, mortgageAssessment)
              },
            })}
          >
            <RadioButtons options={saleTypeOptions()} />
          </Form.Item>
        ) : null}

        {saleType === "mortgage" && mortgageAssessment?.snapshot?.netLoanCoverage > 70 && (
          <Form.Item required name={"bankLoanSubType"} label={t("Bank Loan Sub Type")} rules={rules}>
            <RadioButtons options={bankLoanSubTypeOptions()} />
          </Form.Item>
        )}

        {showBookingPlatforms ? (
          <>
            <Form.Item name="bookingPlatform" label={t("Booking Platform")} rules={rules} initialValue={-1}>
              <RadioButtons
                options={activeBookingPlatforms}
                getValue={e => e?.id}
                onChange={() => {
                  form.setFieldsValue({ bookingPlatformAttachment: [] })
                  form.resetFields(["bookingPlatformAttachment"])
                }}
              />
            </Form.Item>
            {bookingPlatform && bookingPlatform !== -1 && (
              <Form.Item
                name={"bookingPlatformAttachment"}
                label={t("Attachment")}
                valuePropName="fileList"
                getValueFromEvent={e => e?.fileList}
                required
                wrapperCol={{ span: 6 }}
                rules={[
                  {
                    validator: (_, value) => {
                      if (bookingPlatform !== -1 && (!value || value.length === 0)) {
                        return Promise.reject(t("This Attachment is Required"))
                      }
                      return Promise.resolve()
                    },
                  },
                ]}
              >
                <UploadDraggerS3
                  key={bookingPlatform}
                  setIsImageUploading={setImageUploading}
                  path={() => `/files/getSignedUrl?enableEncryption=false&requestType=putObject`}
                  popupPreviewProp
                  uploadDescription=""
                  uploadTitle=""
                  allowedFiles="image/jpeg, image/jpg, image/png, application/pdf"
                  disabled={!bookingPlatform || bookingPlatform === -1}
                  style={{ maxWidth: 90 }}
                />
              </Form.Item>
            )}
          </>
        ) : null}
      </Group>
    </>
  )
}
export default SaleTypeBookingOptions
